
import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";
const HorizontalCarrusel = ({children,title,outputStart, outputEnd}) => {
  const targetRef = useRef(null);
  const {scrollYProgress} = useScroll({
    target: targetRef,
    offset: ["start start", "end end"]
  });
  // console.log(scrollYProgress);

  
  const x = useTransform( scrollYProgress, [0, 1], [outputStart, outputEnd]);
  return (
    <div ref={targetRef} className="relative h-[400vh] md:h-[350vh]">
    
      <div
        className="sticky top-0 h-[80vh] pt-10 flex flex-col justify-center items-start overflow-hidden gap-10"
        > 
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-primaria font-bold px-10 place-self-end">{title}</h2>
        <motion.div style={{ x }} className="flex gap-20">
            {children}
          {/* {[...Array(6)].map((_, i) => (
            <div
            key={i}
              className="w-[80vw] h-[60vh] flex-shrink-0 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white text-4xl flex items-center justify-center shadow-xl"
            >
            Slide {i + 1}
            </div>
            ))} */}
        </motion.div>
      </div>
    </div>
  );
};

export default HorizontalCarrusel;
